module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/ladle-0b206ae1f41f52050e0bf600e74eb5f2.svg";